<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}->{{title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="评分设置" name="first">
                <child1></child1>
            </el-tab-pane>

            <el-tab-pane label="级别设置" name="second">
                <child2></child2>    
            </el-tab-pane>

            <el-tab-pane label="表彰设置" name="three">
                <child3></child3>    
            </el-tab-pane>

            <el-tab-pane label="区县审核人" name="four">
                <child4></child4>    
            </el-tab-pane>

        </el-tabs>
    </div>
</template>

<script>
    import scoreType from './ScoreType.vue'
    import rewardType from './RewardType.vue'
    import areaType from './AreaType.vue'
    import areaTeacher from './AreaTeacher.vue'

    export default {
        name:"BasisMain",
        components:{
            child1:scoreType,
            child2:rewardType,
            child3:areaType,
            child4:areaTeacher,
        },
        data() {
            return {
                menuName:"",
                //默认第一个选项卡
                activeName: "first",
                title:"评分设置"
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
        },
        methods:{
            handleClick(tab) {
                if(tab.name == "first") {
                    this.title="评分设置";
                }
                if(tab.name == "second") {
                    this.title="级别设置";
                }
                if(tab.name == "three") {
                    this.title="表彰设置";
                }
                if(tab.name == "four") {
                    this.title="区县审核人";
                }
            }
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/basis/BasisMain.vue